<template>
  <div v-loading="loading.length">
    <div class="row">
      <div class="col-md-12">
        <div class="services-card has-data">
          <div class="row justify-content-center align-items-center no-gutters">
            <div class="col-lg-2">
              <i class="material-icons">check_circle</i>
            </div>
            <div class="col-lg-4">
              <div class="subtitle">Servicios con datos en la plataforma</div>
              <h2>{{count}} Servicios</h2>
            </div>
          </div>
        </div>
      </div>
      <!--
      <div class="col-md-6">
        <div class="services-card not-data">
          <div class="row justify-content-center align-items-center no-gutters">
            <div class="col-lg-2">
              <i class="material-icons">cancel</i>
            </div>
            <div class="col-lg-7">
              <div class="subtitle">Servicios sin datos en la plataforma</div>
              <h2>{{institutions.filter(d => {return !d.has_data}).length}} Servicios</h2>
            </div>
          </div>
        </div>
      </div>
      -->
    </div>
    <table class="table table-striped institutions-table">
      <thead>
        <tr>
          <th>Servicio</th>
          <th>Tiene datos publicados</th>
          <th>Tipo de datos</th>
          <th>Detalle</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="d in institutions">
          <td>{{d.nombre}} {{d.estado_descripcion ? '('+d.estado_descripcion+')' : ''}}</td>
          <td class="text-center">
            <span v-if="d.has_data" class="has-data">
              <i class="material-icons">check_circle</i>
              Sí
            </span>
            <span v-else class="not-data">
              <i class="material-icons">cancel</i>
              No
            </span>
          </td>
          <td>
            <template v-if="d.has_data">{{d.agregado ? 'Agregado' : 'Transaccional'}}</template>
          </td>
          <td>
            <a
              v-if="d.has_data"
              :href="'/institutions/'+d.partida+'/'+d.capitulo"
              class="ver-detalle"
            >
              Ver detalle
              <i class="material-icons">arrow_forward</i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <!--
    <h3>Instituciones no participantes</h3>

    <table class="table table-striped institutions-table">
      <thead>
        <tr>
          <th>Servicio</th>
          <th>Detalle</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="d in otherInstitutions">
          <td>{{d.nombre}}</td>

          <td>{{d.estado_descripcion}}</td>
        </tr>
      </tbody>
    </table>
    -->
  </div>
</template>
<script>
import axios from 'axios';

export default {
    data: function() {
        return {
            loading: [],
            data: [],
            count: 0
        };
    },
    computed: {
        institutions: function() {
            return this.data.filter(d => !d.estado_descripcion);
        },
        otherInstitutions: function() {
            return this.data.filter(d => d.estado_descripcion);
        }
    },
    mounted: function() {
        this.loading.push(true);
        axios.get('/api/v1/institutions').then(response => {
            this.loading.pop();
            this.data = response.data.filter(d => d.estado_mostrar);
        });
        axios
            .get('/api/v1/data/pagos', {
                params: {
                    where: { periodo: this.$store.state.defaultYear },
                    distinct: JSON.stringify(['partida', 'capitulo'])
                }
            })
            .then(response => {
                this.loading.pop();
                this.count = response.data.length;
            })
            .catch(e => {
                this.loading.pop();
            });
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/InstitutionsStatus.vue